import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/home/HomePage';
import CustomSoftwareDevelopment from '../pages/services/CustomSoftwareDevelopment';
import WebDevelopment from '../pages/services/WebDevelopment';
import ProductManagement from '../pages/services/ProductManagement';
import Blog from '../pages/academy/blog';
import BlogPage from '../pages/academy/blogPage';
import Careers from '../pages/careers';
import OurWorks from '../pages/OurWorks';
import AboutUs from '../pages/AboutUs';
import CallModal from '../pages/services/CallModal';
import Contacts from '../pages/contact/contactus';
import CodeOfConduct from '../components/ui/codeofconduct';
import Login from '../pages/admin/Login';
import Dashboard from '../pages/admin/Dashboard';
import AdminBlog from '../pages/admin/Blog';
import Testimonials from '../pages/admin/Testimonials';
import ProductDevelopment from '../pages/product_development';
import CustomerEngagement from '../pages/customer_engagement';
import OperationalTeams from '../pages/operational_teams';

const AppRoutes = () => {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="/components/mainpage" element={<HomePage />} />
      <Route path="/services/Custom_software_development" element={<CustomSoftwareDevelopment />} />
      <Route path="/services/Web_app_development" element={<WebDevelopment />} />
      <Route path="/services/product_management" element={<ProductManagement />} />
      <Route path="/academy/blog" element={<Blog />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/our_works" element={<OurWorks />} />
      <Route path="/about_us" element={<AboutUs />} />
      <Route path="/services/call_modle" element={<CallModal />} />
      <Route path="/Contacts" element={<Contacts />} />
      <Route path="/Code_of_conduct" element={<CodeOfConduct />} />
      <Route path="/admin" element={<Login />} />
      <Route path="/admin/dashboard" element={<Dashboard />} />
      <Route path="/admin/blog" element={<AdminBlog />} />
      <Route path="/academy/blog/:id" element={<BlogPage />} />
      <Route path="/customer/review/" element={<Testimonials />} />
      <Route path="/Product_development" element={<ProductDevelopment />} />
      <Route path="/customer_engagement" element={<CustomerEngagement />} />
      <Route path="/Operational_teams" element={<OperationalTeams />} />
    </Routes>
  );
};

export default AppRoutes;

